import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../styles/modal.module.css'
import { toast } from 'react-toastify';
import StateContext from '../context/state/StateContext';
import UserContext from '../context/user/UserContext';
import axios from 'axios';
import { FaLink } from "react-icons/fa6";
import { AiOutlineFolderOpen } from "react-icons/ai";
import { IoMdAlarm } from "react-icons/io";
import { IoFlag } from "react-icons/io5";
import { IoCheckmarkSharp } from "react-icons/io5";
import { IoIosMic } from "react-icons/io";
import Links from './Links';
import useVoiceRecorder from './useVoiceRecorder';
import { FaRegCircleStop } from "react-icons/fa6";
import CustomReminder from './CustomReminder';
import { IoSearch } from "react-icons/io5";
import Fuse from 'fuse.js';


const AddTag = (props) => {

    const { isRecording, audioBlob, startRecording, stopRecording } = useVoiceRecorder();
    const { ticket, setTicket, setTickets, token, employees, setEmployees, setLoading, groupDetails, reminderData, setReminderData, agencies, setAgencies, agencyDetails, setAgencyDetails, requests, setRequests } = useContext(StateContext)
    const { user, getEmployees, fetchGroupDetails, getTags } = useContext(UserContext)
    const [select, setSelect] = useState('');
    const [drop, setDrop] = useState(Array(2).fill(false));
    const [disabled, setDisabled] = useState(true);
    const [assigned, setAssigned] = useState([]);
    const [clientName, setClientName] = useState({ id: '', name: '' });
    const [error, setError] = useState('');
    const [fields, setFields] = useState({ component: '', open: false });
    // const [link, setLink] = useState('');
    // const [links, setLinks] = useState([]);
    // const [files, setFiles] = useState([]);
    // const [priority, setPriority] = useState('Low');
    // const [dateTime, setDateTime] = useState({ date: '', time: '' });
    // const [repeat, setRepeat] = useState('does_not_repeat')
    // const [repeatChecked, setRepeatChecked] = useState(false);
    // const [group, setGroup] = useState('')
    // const [agency, setAgency] = useState('')
    // const [allEmployees, setAllEmployees] = useState(employees);
    // const [searchQuery, setSearchQuery] = useState('');
    // const [filteredAgencies, setFilteredAgencies] = useState();
    // const [agencyQuery, setAgencyQuery] = useState('');
    // const [filteredEmployees, setFilteredEmployees] = useState();
    const [formDetails, setFormDetails] = useState({name:"",})
    

    const handleChange = (e) => {
        setDisabled(false)
        setError('')
        setFormDetails({ ...formDetails, [e.target.name]: e.target.value })
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading({ open: true, text: "Adding" })

            const response = await axios.post(
                process.env.REACT_APP_API_URL + "api/agency/createTag",
                formDetails,
                {
                    headers: {
                        // 'Content-Type': 'multipart/form-data',
                        'Content-Type': 'application/json',
                        'auth-token': `${token}`
                    }
                }
            );
            const json = response.data;
            if (json.success) {
                toast.success(json.message)
                props.close({ open: false, component: '' })
                getTags()
            } else {
                toast.error(json.error || json.message)
                setError(json.message || json.message[0].msg)
            }

        } catch (error) {
            console.log(error);
            // setError(error.response.data.message || error.response.data.message[0].msg)
            toast.error(error)
            setError(error.response.data.message)
        } finally {
            setLoading({ open: false, text: '' })
        }
    }




    return (
        <>
            <div className={`${styles.smallDrop} ${fields.open ? styles.active : ''} `}></div>
            {/* <div className={`${styles.small_modal} ${fields.open ? styles.active : ''}`}>
                {smallComponent()}
            </div> */}
            <div className={styles.head}>
                <h3>Add Tag</h3>
                <i className={`bx bx-x ${styles.close}`} onClick={() => props.close({ open: false, component: '' })}></i>
            </div>
            <form action="" className='h-100' onSubmit={handleSubmit}>
                <div className={styles.form_container}>
                    <div className="inputField" style={{ border: "1px solid #ddd" }}>
                        <input type="text" name='name' placeholder='Enter a Tag Name' onChange={handleChange} required />
                    </div>
                    {error ? <p style={{ color: "red" }}>{error}</p> : null}
                </div>
                <div className={styles.foot}>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                        <button type='button' className="button2 cancel" onClick={() => props.close({ open: false, component: '' })}>Cancel</button>
                        <button type='submit' className={`button2 ${disabled ? 'disabled' : ''}`} disabled={disabled}>Add</button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default AddTag;
